<script setup lang="ts">
import { ref } from 'vue';
import { Button } from '@toruslabs/vue-components/Button';
import { useClaimStore } from '../../store/claimStore';

// Assets
import Code from '../../assets/claim/code.svg';
import IconBack from '../../assets/claim/icon-back.svg';


const claimStore = useClaimStore();
const inviteCode = ref('');
const isLoading = ref(false);
const invalidCode = ref(false);

const onCodeInput = (event: Event) => {
    invalidCode.value = false;
    const inputValue = (event.target as HTMLInputElement).value;
    inviteCode.value = inputValue;
}

const onClaimCode = async () => {
    if (!inviteCode.value) return;
    isLoading.value = true;
    const result = await claimStore.verifyInviteCode({ code: inviteCode.value });
    isLoading.value = false;
    if (!result) {
        invalidCode.value = true;
    }
}
</script>

<template>
    <Button class="mb-2 !text-moca-gray-3 !text-sm !font-semibold !bg-moca-transparent !px-0" @on-click="claimStore.showClaimMethods">
        <img :src="IconBack" class="w-4" />
        <p>Back</p>
    </Button>
    <div class="flex flex-col justify-center items-center gap-4 h-[428px]">
        <p class="text-moca-white-80 text-center text-base font-semibold px-12">
            Please enter your invite code to claim Moca ID.
        </p>
        <img :src="Code" class="w-[100px]" />
        <input :input="inviteCode" @input="event => onCodeInput(event)"
            class="rounded-full border-2 border-black h-12 px-6 focus:border-moca-yellow focus-within:border-moca-yellow focus:outline-none w-full"
            placeholder="Enter invite code" />
        <p v-if="invalidCode" class="text-moca-error-red">Invalid/ Used Invite Code</p>
        <Button class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6"
            :class="{ 'opacity-50': !inviteCode }" @on-click="onClaimCode" :loading="isLoading">
            Claim with code
        </Button>
    </div>
</template>
